import * as tslib_1 from "tslib";
import { SnackbarService } from './../shared/services/snackbar.service';
import { OnInit, ChangeDetectorRef, } from '@angular/core';
import { AddOccurenceModalComponent } from './add-occurence-modal/add-occurence-modal.component';
import { MatDialog, MatDialogConfig, MatTableDataSource, MatPaginator, MatSort, MatInput, MatSelect, } from '@angular/material';
import { OccurencesService } from './occurences.service';
import { AuthService } from '../core/auth/auth.service';
import { Sort } from '@angular/material';
import { CONSTANTS } from '@app/shared/constants';
import { FormGroup, FormBuilder, FormControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { UtilService } from '@app/shared/utils';
import { APP_DATE_FORMATS } from './add-occurence-modal/occurence-dates/date-adapter';
import { Spreadsheet } from '@app/shared/export/spreadsheet';
import { differenceInCalendarDays } from 'date-fns';
import { idMask } from '@app/shares/services/text-mask/text-mask';
var namePage = 'cadastro/cadastroDemanda';
var ɵ0 = APP_DATE_FORMATS;
var OccurencesComponent = /** @class */ (function () {
    function OccurencesComponent(dialog, occurrencesService, authService, formBuilder, snackbarService, cdref, utils) {
        var _this = this;
        this.dialog = dialog;
        this.occurrencesService = occurrencesService;
        this.authService = authService;
        this.formBuilder = formBuilder;
        this.snackbarService = snackbarService;
        this.cdref = cdref;
        this.utils = utils;
        this.closedModel = false;
        this.isVisualization = false;
        this.errorDownloadFile = false;
        this.infoDisabledNotification = CONSTANTS.INFO_DISABLE_NOTIFICAION;
        this.occurrenceTooltip = new MatTableDataSource();
        this.displayedColumns = ['id', 'database', 'dataevento', 'tipo', 'nome', 'cpfcnpj', 'status', 'visualizar'];
        this.dataSource = new MatTableDataSource();
        this.pageSizeOptions = [10, 20, 30];
        this.currentPage = 0;
        this.pageSize = this.pageSizeOptions[0];
        this.canLoadFilters = true;
        this.styleChanged = false;
        this.displayedColumnsExpandable = ['id', 'database', 'dataevento', 'tipo', 'nome', 'cpfcnpj', 'status'];
        this.dataSourceExpandedItem = new MatTableDataSource();
        this.showLoading = false;
        this.minDate = new Date(1970, 1, 1);
        this.idMask = idMask;
        this.isMobile = false;
        this.isExpansionDetailRow = function (i, row) { return row.hasOwnProperty('detailRow'); };
        this.occurrenceDateOptions = [
            { value: "dateRequest", viewValue: "Data da Solicitação" },
            { value: "dateEvent", viewValue: "Data do Evento" }
        ];
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe(function (user) {
            _this.authUser = user;
        });
    }
    OccurencesComponent.prototype.ngOnInit = function () {
        this.isMobile = window.innerWidth <= 760;
        this.buildFilterForm();
        this.searchOccurrence();
        this.clearFilter();
    };
    OccurencesComponent.prototype.openDialog = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.maxWidth = '90%';
        dialogConfig.width = '90%';
        dialogConfig.maxHeight = '95%';
        dialogConfig.panelClass = 'occurrence-dialog';
        dialogConfig.height = '95%';
        this.dialogRef = this.dialog.open(AddOccurenceModalComponent, dialogConfig);
        this.dialogRef.afterClosed().subscribe(function () {
            _this.searchOccurrence();
        });
    };
    OccurencesComponent.prototype.handlePage = function (e) {
        this.currentPage = e.pageIndex;
        this.pageSize = e.pageSize;
        this.searchOccurrence();
    };
    OccurencesComponent.prototype.sortOccurrence = function (sortCol) {
        this.searchOccurrence();
        this.sort.active = sortCol.active;
        this.sort.direction = sortCol.direction;
    };
    OccurencesComponent.prototype.getOccurrenceParameters = function () {
        var cpfCnpj = this.filterForm.get('fCpfCnpj').value;
        if (cpfCnpj == '') {
            cpfCnpj = null;
        }
        var fCode = this.filterForm.get('fCode').value;
        if (fCode == '') {
            fCode = null;
        }
        var occurrenceIdNumberValue = null;
        var occurrenceIdStringValue = this.filterForm.get('occurrenceId').value;
        if (occurrenceIdStringValue && occurrenceIdStringValue != '') {
            occurrenceIdNumberValue = Number(occurrenceIdStringValue);
        }
        var occurrencePaginationParameters = {
            userName: this.authUser.gestor,
            pageIndex: this.currentPage,
            pageSize: this.pageSize,
            sortColumn: this.getActiveSortColumn(this.sort),
            sortOrder: this.getDirectionSort(),
            occurrenceFilterDate: this.filterForm.get('occurrenceFilterDate').value,
            startDate: this.filterForm.get('startDate').value,
            endDate: this.filterForm.get('endDate').value,
            occurrenceId: (occurrenceIdNumberValue == null || isNaN(occurrenceIdNumberValue) || (occurrenceIdNumberValue > Number.MAX_SAFE_INTEGER)) ? null : occurrenceIdNumberValue,
            types: this.filterForm.get('types').value,
            status: this.filterForm.get('status').value,
            fCode: fCode,
            fCpfCnpj: cpfCnpj ? cpfCnpj.replace(/[^\d]+/g, '') : cpfCnpj
        };
        return occurrencePaginationParameters;
    };
    OccurencesComponent.prototype.getActiveSortColumn = function (sort) {
        if (sort) {
            if (sort.active === 'status') {
                return 'STATUS_NAME';
            }
            else if (sort.active === 'database') {
                return 'CREATION_DATE_TIME';
            }
            else if (sort.active === 'unreadCommentNotification') {
                return 'UNREAD_COMMENT_NOTIFICATION';
            }
        }
        else {
            return 'UNREAD_COMMENT_NOTIFICATION';
        }
    };
    OccurencesComponent.prototype.getDirectionSort = function () {
        if (this.sort) {
            if (this.sort.direction.trim() !== '') {
                return this.sort.direction.toUpperCase().toString();
            }
            else {
                return this.sort.start.toUpperCase().toString();
            }
        }
        else {
            return 'DESC'.toString();
        }
    };
    OccurencesComponent.prototype.viewOccurrence = function (occurrence) {
        var _this = this;
        if (!this.closedModel) {
            this.closedModel = true;
            this.occurrencesService.getOcurrenceById(occurrence.id).subscribe(function (occurrenceResponse) {
                var dialogConfig = new MatDialogConfig();
                dialogConfig.autoFocus = true;
                dialogConfig.maxWidth = '90%';
                dialogConfig.width = '90%';
                dialogConfig.maxHeight = '95%';
                dialogConfig.height = '95%';
                dialogConfig.panelClass = 'occurrence-dialog';
                dialogConfig.data = occurrenceResponse;
                _this.occurrencesService.getHasCommentsByOcurrenceById(occurrence.id).subscribe(function (result) {
                    _this.occurrencesService.currentGestorDemanda = occurrence.userName;
                    occurrenceResponse.hasComments = result;
                    _this.showModal(dialogConfig);
                });
            }, function (error) {
                //- Threat Error
            });
        }
    };
    OccurencesComponent.prototype.clearFilter = function () {
        this.appliedFilter = false;
        this.pageSize = this.pageSizeOptions[0];
        this.filterForm.reset();
        if (this.paginator)
            this.paginator.pageSize = 0;
        this.searchOccurrence(true);
        if (this.isMobile) {
            this.filterForm.get('startDate').enable();
            this.filterForm.get('endDate').enable();
        }
        else {
            this.filterForm.get('startDate').disable();
            this.filterForm.get('endDate').disable();
        }
    };
    OccurencesComponent.prototype.showModal = function (matDialogConfig) {
        var _this = this;
        this.dialogRef = this.dialog.open(AddOccurenceModalComponent, matDialogConfig);
        this.dialogRef.afterClosed().subscribe(function (result) {
            _this.searchOccurrence();
            _this.closedModel = false;
        });
    };
    OccurencesComponent.prototype.cpfCnpjValidator = function (control) {
        if (control.value) {
            if (control.value !== '' && !OccurencesService.cpfCnpjValidator(control.value)) {
                return { 'cpfCnpjValidator': true };
            }
        }
        return null;
    };
    OccurencesComponent.prototype.getDisplayedColumns = function (showColumnManager) {
        this.displayedColumns = Array[''];
        if (showColumnManager) {
            this.displayedColumns = ['id', 'database', 'dataevento', 'tipo', 'nome', 'cpfcnpj', 'gestor', 'status', 'visualizar'];
        }
        else {
            this.displayedColumns = ['id', 'database', 'dataevento', 'tipo', 'nome', 'cpfcnpj', 'status', 'visualizar'];
        }
    };
    OccurencesComponent.prototype.listOccurrencesByParameters = function (occurrencePaginationParameters) {
        var _this = this;
        this.showLoading = true;
        this.occurrenceListIsEmpty = false;
        this.occurrenceListFilterIsEmpty = false;
        this.showGrid = true;
        if (occurrencePaginationParameters) {
            this.occurrencesService.getOccurenceListPost(occurrencePaginationParameters).subscribe(function (occurrenceResponse) {
                if (occurrenceResponse) {
                    _this.dataSource = new MatTableDataSource(occurrenceResponse['content']);
                    if (_this.dataSource.data.length <= 0) {
                        _this.showGrid = false;
                        if (_this.appliedFilter) {
                            _this.occurrenceListFilterIsEmpty = true;
                        }
                        else {
                            _this.occurrenceListIsEmpty = true;
                        }
                    }
                    else {
                        _this.getDisplayedColumns(_this.dataSource.data["0"].userName);
                    }
                    if (_this.paginator) {
                        _this.paginator.length = occurrenceResponse['totalElements'];
                    }
                }
                else {
                    _this.dataSource = new MatTableDataSource();
                    _this.showGrid = false;
                }
                _this.showLoading = false;
            }, function () { _this.showLoading = false; });
        }
    };
    OccurencesComponent.prototype.buildFilterForm = function () {
        this.filterForm = this.formBuilder.group({
            occurrenceFilterDate: [''],
            startDate: [{ value: '', disabled: true }],
            endDate: [
                { value: '', disabled: true },
                [this.validatorEndDateLess.bind(this), this.validatorComparationDate.bind(this)]
            ],
            occurrenceId: [null],
            types: [''],
            status: [''],
            fCode: [''],
            fCpfCnpj: [null, [this.cpfCnpjValidator]],
        }, { validators: [startEndValidator, emptyStartDateValidator] });
        if (this.isMobile) {
            this.filterForm.get('startDate').enable();
            this.filterForm.get('endDate').enable();
        }
    };
    Object.defineProperty(OccurencesComponent.prototype, "startDate", {
        get: function () { return this.filterForm.get('startDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OccurencesComponent.prototype, "endDate", {
        get: function () { return this.filterForm.get('endDate'); },
        enumerable: true,
        configurable: true
    });
    OccurencesComponent.prototype.updateFormControl = function (formControlName, event) {
        this.filterForm.get(formControlName).setValue(event.value);
    };
    OccurencesComponent.prototype.loadFilters = function () {
        if (this.canLoadFilters) {
            this.loadStatusCombobox();
            this.loadTypesCombobox();
            this.canLoadFilters = false;
        }
    };
    OccurencesComponent.prototype.loadTypesCombobox = function () {
        var _this = this;
        this.showLoading = true;
        this.occurrencesService.getOccurenceTypes().subscribe(function (response) {
            _this.typesCombo = response;
            _this.showLoading = false;
        }, function (err) { return _this.handleError('Não foi possível carregar os tipos de demandas.'); }, function () { _this.showLoading = false; });
    };
    OccurencesComponent.prototype.loadStatusCombobox = function () {
        var _this = this;
        this.occurrencesService.getStatus().subscribe(function (response) {
            _this.statusCombo = response;
        }, function (err) { return _this.handleError('Não foi possível carregar os status de demandas.'); });
    };
    //Deprecated
    OccurencesComponent.prototype.loadPortfoliosCombobox = function () {
        var _this = this;
        this.occurrencesService.getPortfolios().subscribe(function (response) {
            _this.portfoliosCombo = response;
        }, function (err) { return _this.handleError('Não foi possível buscar os fundos de carteiras.'); });
    };
    OccurencesComponent.prototype.validatorEndDateLess = function (control) {
        if (control && control.value) {
            if (this.filterForm.controls['startDate'].value) {
                if (control.value < this.filterForm.controls['startDate'].value) {
                    return { notValid: true };
                }
            }
            else {
                return { notValid: true };
            }
        }
        return null;
    };
    OccurencesComponent.prototype.validatorComparationDate = function () {
        var result = differenceInCalendarDays(new Date(this.filterForm.controls['endDate'].value), new Date(this.filterForm.controls['startDate'].value));
        if (result > 60) {
            return { notComparation: true };
        }
        return null;
    };
    OccurencesComponent.prototype.isEntityNullable = function (value) {
        return value ? true : false;
    };
    OccurencesComponent.prototype.submitEvent = function (category, action, label) {
    };
    OccurencesComponent.prototype.handleError = function (message) {
        this.snackbarService.showSnackbar(message, CONSTANTS.GLOBAL.OK.toUpperCase());
    };
    OccurencesComponent.prototype.applyFilter = function () {
        this.appliedFilter = true;
        if (!this.filterForm.valid) {
            if (this.filterForm.hasError('emptyStartDate')) {
                this.handleError('A data inicial não pode ser vazia.');
            }
            else if (this.filterForm.hasError('startEndInvalid')) {
                this.handleError('A data inicial não pode ser maior que a data final.');
            }
            else {
                this.handleError('O filtro possui campos inválidos.');
            }
        }
        else {
            this.searchOccurrence(true);
        }
    };
    OccurencesComponent.prototype.searchOccurrence = function (pageIndex) {
        var parameters = this.getOccurrenceParameters();
        if (pageIndex) {
            parameters.pageIndex = 0;
            if (this.paginator) {
                this.paginator.pageIndex = 0;
            }
        }
        if (!Array.isArray(parameters.types)) {
            parameters.types = [];
        }
        if (!Array.isArray(parameters.status)) {
            parameters.status = [];
        }
        this.listOccurrencesByParameters(parameters);
    };
    OccurencesComponent.prototype.setStyleExpandeElems = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (res) {
                        var allColumnsId = document.getElementsByClassName('cdk-column-id');
                        ;
                        var elemIdReference = allColumnsId[0];
                        var elemExpanded = document.getElementById('custom-style-id');
                        if (elemIdReference && elemExpanded) {
                            for (var i = 1; i < allColumnsId.length; i++) {
                                var columId = allColumnsId[i];
                                columId.style.padding = '0px';
                                columId.style.width = elemIdReference.offsetWidth + "px";
                                columId.style.height = elemIdReference.offsetHeight + "px";
                            }
                            res();
                        }
                    })];
            });
        });
    };
    OccurencesComponent.prototype.seeMoreTypes = function (element) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.showExpandedItens(element)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OccurencesComponent.prototype.showExpandedItens = function (element) {
        if (this.expandedElement && this.expandedElement === element) {
            this.expandedElement = null;
        }
        else {
            var lenTypes = element.occurrenceTypeName.length;
            var clonedOccurrenceTypes = [];
            for (var i = 0; i < lenTypes; i++) {
                clonedOccurrenceTypes.push({
                    cnpjCpf: element.cnpjCpf,
                    creationDateTime: element.creationDateTime,
                    description: element.description,
                    fundName: element.fundName,
                    id: element.id,
                    occurrenceTypeName: element.occurrenceTypeName[i],
                    statusName: element.statusName,
                    userName: element.userName
                });
            }
            this.dataSourceExpandedItem = new MatTableDataSource(clonedOccurrenceTypes);
            this.expandedElement = element;
        }
    };
    OccurencesComponent.prototype.exportSpreadsheet = function () {
        var _this = this;
        this.showLoading = true;
        var rowLimit = 500;
        var pagination = this.getOccurrenceParameters();
        pagination.pageIndex = 0;
        pagination.pageSize = rowLimit;
        pagination.types = pagination.types || [];
        pagination.status = pagination.status || [];
        this.occurrencesService.getOccurenceListPost(pagination)
            .subscribe(function (response) {
            var tableToExport = _this.convertToSpreadsheet(response.content);
            if (tableToExport.length >= rowLimit) {
                _this.showLimitToExportMessage(rowLimit);
            }
            var spreadsheetGenerator = new Spreadsheet('demandas', tableToExport);
            spreadsheetGenerator.generateSpreadsheet();
            _this.showLoading = false;
        }, function () { return _this.showLoading = false; });
    };
    OccurencesComponent.prototype.convertToSpreadsheet = function (table) {
        return table.map(function (ocurrence) { return ({
            'id': ocurrence.id,
            'data solicitação': ocurrence.creationDateTime,
            'data evento': ocurrence.eventDate,
            'tipo': ocurrence.occurrenceTypeName,
            'nome': ocurrence.fundName,
            'CPF/CNPJ': ocurrence.cnpjCpf,
            'status': ocurrence.statusName,
        }); });
    };
    OccurencesComponent.prototype.showLimitToExportMessage = function (limit) {
        this.handleError(this.messageExportLimit(limit));
    };
    OccurencesComponent.prototype.messageExportLimit = function (limit) {
        return "O limite para a exporta\u00E7\u00E3o \u00E9 de " + limit + " registros,"
            + (" apenas os primeiros " + limit + " ser\u00E3o exibidos, voc\u00EA pode refazer a busca para")
            + ' exportar todas as demandas que necessita visualizar.';
    };
    OccurencesComponent.prototype.onSelectionChange = function (_a) {
        var value = _a.value;
        if (value === 'dateRequest' || value === 'dateEvent') {
            this.filterForm.get('startDate').enable();
            this.filterForm.get('endDate').enable();
        }
    };
    OccurencesComponent.prototype.emptyFilter = function () {
        var emptyDates = !this.getField('startDate') && !this.getField('endDate');
        var empyDropdowns = !this.getField('types')
            && !this.getField('status')
            && !this.getField('fCode');
        return emptyDates
            && empyDropdowns
            && !this.getField('occurrenceId')
            && !this.getField('fCpfCnpj');
    };
    OccurencesComponent.prototype.getField = function (field) {
        return this.filterForm.controls[field].value;
    };
    OccurencesComponent.prototype.handlePermissionComment = function (userName) {
        return true; // TODO: regra será revisada
    };
    OccurencesComponent.prototype.handleNullOrUndefined = function (element) {
        return this.utils.handleNullOrUndefined(element);
    };
    return OccurencesComponent;
}());
export { OccurencesComponent };
;
export var startEndValidator = function (control) {
    var startDate = control.get('startDate');
    var endDate = control.get('endDate');
    return startDate && startDate.value && endDate && endDate.value && startDate.value > endDate.value ? { 'startEndInvalid': true } : null;
};
export var emptyStartDateValidator = function (control) {
    var startDate = control.get('startDate');
    var endDate = control.get('endDate');
    return (!startDate || !startDate.value) && endDate && endDate.value ? { 'emptyStartDate': true } : null;
};
export { ɵ0 };
